import Line from './Line';
import Circle from './Circle';

export { Line, Circle };

export default {
  Line: Line,
  Circle: Circle
};


//////////////////
// WEBPACK FOOTER
// ./~/rc-progress/es/index.js
// module id = 1558
// module chunks = 14